import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { QueryProvider } from './lib/QueryProvider';
// Loaded before `./index.css` so index.css's token-driven overrides (same-selector, same-
// specificity) win the cascade by source order — the *component* import for `<ToastContainer>` /
// `toast()` has to come from `react-toastify/unstyled` for that source-order win to stick (see
// App.tsx and lib/events.ts).
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

createRoot(container).render(
  <StrictMode>
    <QueryProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryProvider>
  </StrictMode>,
);
